import ads from './Ads';
import default_image from './DefaultImage';
import default_image_cta from './DefaultImageWithCta';
import default_video from './DefaultVideo';
import default_video_cta from './DefaultVideoWithCta';
import flow_image from './FlowImage';
import flow_image_with_cta from './FlowImageWithCta';
import flow_video from './FlowVideo';
import flow_video_with_cta from './FlowVideoWithCta';

export const default_renderers = [
    default_image,
    default_image_cta,
    default_video,
    default_video_cta,
];

export const flow_renderers = [
    flow_image,
    flow_image_with_cta,
    flow_video,
    flow_video_with_cta,
];

export const ads_renderers = [ads];

export const renderers = [...default_renderers, ...flow_renderers];
